import Backbone from 'backbone'
import _ from 'lodash'
import Tooltip from 'scoreboard/components/tooltip'
import $ from 'jquery'

/**
 * Setup your HTML like this, and the data-action attribute will determine the
 * text of the tooltip:
 *
 * <a class="button button-covert" data-action="{{i18n 'common.edit'}}">
 *     {{{icon 'edit'}}}
 * </a>
 *
 * Setup your JavaScript like this:
 *
 * render: function() {
 *     // all your render logic
 *     this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
 * },
 *
 * OR, If the component may be re-rendered (i.e. Historical Performance tab navigation) put it in the initialize function:
 *
 * initialize: function() {
 *		...
 *		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
 *	},
 *
 * remove: function() {
 *     Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips], 'remove')
 * }
 */
var CovertButtonTooltips = Backbone.View.extend({

	events: {
		'mouseenter .button-covert': 'tooltip',
		'mouseleave .button-covert': 'removeTooltip'
	},

	tooltip: function(e) {
		var target = $(e.currentTarget)
		var tooltipContent = target.data('action')

		if (!_.isNil(target.data('header'))) {
			tooltipContent =
				`<div class="header">${target.data('header')}</div> ${tooltipContent}`
		}

		if (!tooltipContent) {
			// note: this is not an error.  some covert buttons may not have
			// tooltips.  For example, the gear icon in the upper right corner
			// of the "Change Total Display" panel in the upper right corner of
			// the Datasets Overview
			return
		}

		if (this._tooltip) {
			this._tooltip.remove()
		}

		this._tooltip = new Tooltip({
			extraClass: 'button-covert-tooltip',
			attachTo: target,
			content: tooltipContent,
			placement: 'above',
			arrow: 'center',
			ignoreAttachToClick: true,
			// If this tooltip is activated from within a dasboard widget, deploy it
			// silently to avoid flickering #42590
			silent: $(target).closest('.widget').length > 0
		}).render()
	},

	removeTooltip: function() {
		this._tooltip && this._tooltip.remove()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._tooltip], 'remove')
	},

	// the same as this.remove(), but doesn't delete this.el.  This is handy if
	// you are going to re-render a portion of a page that contained covert
	// buttons
	cleanup: function() {
		this.undelegateEvents()
		_.invokeMap([this._tooltip], 'remove')
	}

})

export default CovertButtonTooltips

CovertButtonTooltips.__filename__ = 'components/covert-button-tooltips.js'
